import { useEffect, useState } from "react";
import { getKatlasStatus } from "@/lib/api";

const DOT = {
    active: "bg-green-500",
    unconfigured: "bg-slate-400",
    rejected: "bg-amber-500",
    unreachable: "bg-red-500",
    error: "bg-red-500",
};

export const NodeStatusPill = () => {
    const [status, setStatus] = useState(null);

    useEffect(() => {
        let alive = true;
        getKatlasStatus()
            .then((d) => alive && setStatus(d))
            .catch(() => alive && setStatus({ state: "unreachable", label: "KATLAS node unreachable" }));
        return () => {
            alive = false;
        };
    }, []);

    const state = status?.state || "unconfigured";
    const label = status?.label || "Checking node…";

    return (
        <div
            data-testid="node-status-pill"
            className="inline-flex items-center gap-2 text-xs text-slate-500"
        >
            <span className="relative flex h-2 w-2">
                <span className={`h-2 w-2 rounded-full ${DOT[state] || "bg-slate-400"}`} />
            </span>
            <span data-testid="node-status-label" className="font-mono tracking-tight">
                {label}
            </span>
        </div>
    );
};
